export default __webpack_public_path__ + "static/media/gallery_14.396a3001.jpg";